import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './app/App.tsx';
import {initClientLogging} from './app/initClientLogging.ts';
import {ErrorBoundary} from './app/ErrorBoundary.tsx';

initClientLogging();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
